/**
 * Seleção dos valores do gráfico "Despesas Dentro da Receita".
 *
 * O gráfico alterna entre dois modos e cada um deve mostrar EXCLUSIVAMENTE os
 * seus próprios números. Existia aqui uma exceção só para a receita: quando a
 * receita realizada era zero, ela era substituída pela planejada. O efeito era
 * uma barra de receita PLANEJADA ao lado de despesas REALIZADAS — o gráfico
 * misturava os dois modos e anunciava dinheiro que ainda não entrou.
 *
 * Zero realizado é uma informação legítima: significa que nada foi realizado.
 */
export type ExpenseInRevenueMode = 'planned' | 'realized';

export interface ExpenseInRevenueTotals {
  revenue: number;
  future: number;
  daily: number;
  monthlyContinuous: number;
  monthlySingle: number;
  monthlyInstallment: number;
}

export const selectExpenseInRevenueTotals = (
  mode: ExpenseInRevenueMode,
  planned: ExpenseInRevenueTotals,
  realized: ExpenseInRevenueTotals
): ExpenseInRevenueTotals => (mode === 'planned' ? planned : realized);
